import { Badge } from '@cargomatic/ui';
import React from 'react';
import { humanize } from 'underscore.string';
export default function StatusBadge({ status }) {
    let color;
    if (status === 'expired') {
        color = 'zinc';
    }
    else if (status === 'confirmed') {
        color = 'green';
    }
    else if (status === 'processing') {
        color = 'yellow';
    }
    else {
        color = 'zinc';
    }
    return React.createElement(Badge, { color: color }, humanize(status));
}
